import { GADataLayer } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
  selector: 'app-compare-header',
  templateUrl: './compare-header.component.html',
  styleUrls: ['./compare-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareHeaderComponent {
  /**
   * Emits an event object back to the parent component - needed for GA
   */
  @Output() closed: EventEmitter<GADataLayer> = new EventEmitter();

  @Input() hasSpecDifferences: boolean;

  /**
   * Fires when close X is clicked - passes in event
   */
  onClose() {
    const gaData = {} as GADataLayer; // TODO populate when we have GA info
    this.closed.emit(gaData);
  }
}
